import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { genericFilter } from "../../utils/utils";

const STORE_NAME = "ORDERS_STORE";

const INIT_STATE = {
  orders: [],
  filteredOrders: [],
  events: [],
  selectedFilters: [],
};

const store = (set) => ({
  ...INIT_STATE,
  setOrders: async (orders) => set(() => ({ orders })),
  setEvents: async (events) => set(() => ({ events })),
  //setSelectedFilters: async (selectedFilters) => set(() => ({ selectedFilters })),
  filterOrders() {
    set((state) => {
      let _SELECTED_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let _ALL_FILTERS = state.selectedFilters
        .map((e) => {
          return { [e.prop]: e.value };
        })
        .reduce(function (acc, x) {
          for (var key in x) acc[key] = x[key];
          return acc;
        }, {});

      let ALL_ORDERS = [];

      if (!!_SELECTED_FILTERS["fechaPromesa"]) {
        delete _SELECTED_FILTERS.fechaPromesa;
      }

      if (!!_SELECTED_FILTERS["fechaFinPromesa"]) {
        delete _SELECTED_FILTERS.fechaFinPromesa;
      }

      console.log(_SELECTED_FILTERS);
      console.log(_ALL_FILTERS);

      const _filteredOrders = genericFilter(
        [...state.orders],
        _SELECTED_FILTERS
      );

      let filtersWithDate = null;

      if (!!_ALL_FILTERS["fechaPromesa"] || !!_ALL_FILTERS["fechaFinPromesa"]) {
        let start = _ALL_FILTERS["fechaPromesa"]
          ? new Date(_ALL_FILTERS["fechaPromesa"])
          : new Date();
        let end = _ALL_FILTERS["fechaFinPromesa"]
          ? new Date(_ALL_FILTERS["fechaFinPromesa"])
          : new Date();

        console.log(start, end);

        filtersWithDate = _filteredOrders.filter((order) => {
          let date = new Date(order.fechaPromesa);
          return date >= start && date <= end;
        });
      }

      return {
        filteredOrders: filtersWithDate
          ? filtersWithDate.length > 0
            ? filtersWithDate
            : -1
          : _filteredOrders.length > 0
          ? _filteredOrders
          : -1,
      };
    });
  },
  addSelectedFilter: (filter) => {
    set((state) => {
      const INDEX_TO_REPLACE = state.selectedFilters.findIndex(
        (f) => f.prop === filter.prop
      );
      console.log(INDEX_TO_REPLACE);

      if (INDEX_TO_REPLACE >= 0) {
        return {
          selectedFilters: [
            ...state.selectedFilters.filter((f) => f.prop !== filter.prop),
            filter,
          ],
        };
      } else {
        return {
          selectedFilters: [...state.selectedFilters, filter],
        };
      }
    });
  },
  removeSelectedFilter: (filter) => {
    set((state) => {
      const _DROPED_FILTERS = state.selectedFilters.filter(
        (e) => e.prop !== filter.prop
      );
      return {
        selectedFilters: _DROPED_FILTERS,
      };
    });
  },
  resetFilters: async () =>
    set(() => ({ selectedFilters: [], filteredOrders: [] })),
})

export const ordersStore = create(
  devtools(store, { name: STORE_NAME })
);
